import React from "react";

const YPPPage = () => {
  return (
    <section>
      <p>
        Yield Protection Points (YPPs) YPPs are a non-yield-bearing digital
        utility token that allow institutions to influence the duration of their
        collateral vaults by adjusting their position in the redemption queue.
        Purpose YPPs provide a free-market mechanism for allocating vault
        duration, enabling institutions to: Extend reward accrual periods
        Optimise yield strategies during high operational velocity Hedge against
        contraction periods in USCY market supply Key Properties Issued by an
        independent Cayman foundation Not a yield-bearing instrument No claim on
        trust assets No revenue share, governance rights, or ownership features
        Fully compatible with GENIUS-compliant architectural rules Earned via
        incentives or acquired on secondary markets Function Institutions spend
        YPPs to move vaults down the queue, extending their yield-earning
        window. Related Concepts Vault Queue Model YPP Foundation How USCY Works
      </p>
    </section>
  );
};

export default YPPPage;
